import { FC } from 'react'

import {
  Badge,
  PageTitle,
  StandardLayout,
  Flex
} from '@sequencehq/core-components'
import { useCustomerContext } from 'Customer/hooks/useCustomerContext'

export const HeaderBreadcrumbs: FC = () => {
  const { customer } = useCustomerContext()

  return (
    <Flex gap="8px" alignItems="center">
      <PageTitle title={[customer.legalName, 'Customers']} />

      <StandardLayout.Breadcrumbs>
        <StandardLayout.Breadcrumbs.Breadcrumb href="/customers">
          Customers
        </StandardLayout.Breadcrumbs.Breadcrumb>
        <StandardLayout.Breadcrumbs.Breadcrumb>
          {customer.legalName}
        </StandardLayout.Breadcrumbs.Breadcrumb>
      </StandardLayout.Breadcrumbs>

      {!!customer.archivedAt && (
        <Badge data-testid="customer.archivedBadge">Archived</Badge>
      )}
    </Flex>
  )
}
